import { EDUCATOR } from '$variables/roles';

const formatUserCurrentSpaceToState = ({ userInfoOnSpaces, spaceId }) => {
  const { id, avatar, code, name, role, isStaffOnly } = userInfoOnSpaces.find(
    (info) => info.id === spaceId
  );

  return {
    id,
    avatar,
    code,
    name,
    isEducator: role === EDUCATOR,
    isStaffOnly,
  };
};

export default formatUserCurrentSpaceToState;
